export default __webpack_public_path__ + "static/media/logo-cast.452f24d2.png";